import React from 'react';
import { connect } from 'react-redux';
import EligibilityAgentModal from './EligibilityAgentModal';
import * as eligibilityActions from '../../../redux/actions/eligibility.actions';

const EligibilityAgentModalContainer = ({
  isOpen,
  verificationId,
  status,
  appliedRules,
  changes,
  issues,
  coverages,
  coordinationTypes,
  isLoading,
  pendingReview,
  onClose,
  onAccept,
  onReject,
}) => {
  if (window.ambulnzConfig?.constants?.ELIGIBILITY_MODE !== 'agent') {
    return null;
  }

  return (
    <EligibilityAgentModal
      open={isOpen}
      verificationId={verificationId}
      status={status}
      appliedRules={appliedRules}
      changes={changes}
      issues={issues}
      coverages={coverages}
      coordinationTypes={coordinationTypes}
      isLoading={isLoading}
      pendingReview={pendingReview}
      onAccept={onAccept}
      onReject={onReject}
      onClose={onClose}
    />
  );
};

const mapStateToProps = state => ({
  isOpen: state.eligibility.changesModal.isOpen,
  verificationId: state.eligibility.changesModal.verificationId,
  status: state.eligibility.changesModal.status,
  appliedRules: state.eligibility.changesModal.appliedRules,
  changes: state.eligibility.changesModal.changes,
  issues: state.eligibility.changesModal.issues,
  coverages: state.infobox.coverages,
  coordinationTypes: state.infobox.coordinationTypes,
  isLoading: state.eligibility.changesModal.isLoading,
  pendingReview: state.eligibility.changesModal.pendingReview,
});

const mapDispatchToProps = dispatch => ({
  onClose: () => dispatch(eligibilityActions.hideChangesModal()),
  onAccept: () => dispatch(eligibilityActions.acceptChanges()),
  onReject: rejectReason => dispatch(eligibilityActions.rejectChanges({ rejectReason })),
});

export default connect(mapStateToProps, mapDispatchToProps)(EligibilityAgentModalContainer);
